import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Unit } from '../../feature/appliance/components/control-board/models/unit.model';
import { LoggedInUserinfo } from 'src/app/models/user.model';


@Injectable()
export class HeaderService {

  private buildingDropdownValue: Unit;
  constructor() { }

  private buildingDropdownChangeSubject = new Subject<any>();
  private userInfoSubject = new BehaviorSubject<LoggedInUserinfo | null>(null);
  private unitTreeIdsSubject = new BehaviorSubject<string[]>([]);

  buildingDropdownChange$ = this.buildingDropdownChangeSubject.asObservable();
  unitTreeIds$ = this.unitTreeIdsSubject.asObservable();
  triggerBuildingDropdownChange(unit: Unit) {
    this.buildingDropdownValue = unit;
    this.buildingDropdownChangeSubject.next(unit);
  }

  setUserInfo(user: LoggedInUserinfo) {
    this.userInfoSubject.next(user);
  }

  getUserInfoValue() {
    return this.userInfoSubject.asObservable();
  }
  getBuildingDropdownValue(): Unit {
    return this.buildingDropdownValue;
  }

  setUnitDropdownUnits(units: Unit[]): void {
    const availableUnits = (units ?? []).filter(unit => !!unit?.id);
    const facilities = availableUnits.filter(unit => unit.level === 0);
    const treeRoots = facilities.length > 0 ? facilities : availableUnits;
    const ids = [...new Set(treeRoots.map(unit => unit.id))];

    this.unitTreeIdsSubject.next(ids);
  }

  getUnitTreeIds(): string[] {
    return this.unitTreeIdsSubject.value;
  }
}
